import React, { memo, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { Input } from 'antd';
import { getComtAppList } from '../../actions/comment';

const selectComment = createSelector(
  state => state.comment,
  comment => comment,
);

function SelectApp(props) {
  const { onSelect } = props;
  const { appList } = useSelector(selectComment);
  const dispatch = useDispatch();
  const [value, setValue] = useState('');

  const handleChange = useCallback(
    ev => {
      ev.persist();
      const inputValue = ev.target.value.trim();
      setValue(inputValue);
      if (inputValue) {
        dispatch(getComtAppList({ word: inputValue }));
      }
    },
    [value],
  );

  return (
    <div className="insert-box">
      {value && appList && (
        <ul className="box-list">
          {appList.length > 0 &&
            appList.map((el, idx) => {
              if (el.keyWord) {
                return (
                  <li
                    className="list-item"
                    key={idx}
                    onClick={e => {
                      e.stopPropagation();
                      onSelect && onSelect({ ...el, name: el.keyWord, softId: el.softID });
                      setValue(null);
                    }}
                  >
                    {el.keyWord}
                  </li>
                );
              }
            })}
          <li
            className="list-item"
            onClick={e => {
              e.stopPropagation();
              onSelect && onSelect({ name: value });
              setValue(null);
            }}
          >
            添加：{value}
          </li>
        </ul>
      )}
      <Input
        placeholder="请输入应用名称"
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
      />
    </div>
  );
}

export default memo(SelectApp);
